import appGlobalReducer from '../slices/appGlobal.slide';
import pokemonReducer from '../slices/pokemon.slice';

const rootReducer = {
  pokemon: pokemonReducer,
  appGlobal: appGlobalReducer,
};

export default rootReducer;
